import { getContainer } from "@neru/base/utils";
import { createRoot } from "react-dom/client";

import reportWebVitals from "./reportWebVitals";

let apiKeys: ROOT_MFA.APIKey[] | undefined;

if (!import.meta.env.PROD && import.meta.env.VITE_MOCK) {
  import("@neru/mock/worker");

  const accountsData = await import("@neru/mock/data/accounts-vonage");
  const masterKey = accountsData.default.master_api_key;

  apiKeys = accountsData.default.allowed_api_keys.map((account) => ({
    apiKey: account.key,
    master: account.key === masterKey,
    suspended: account.suspended,
  }));
}

const module = await import("./Bootstrap");
const rootElement = getContainer();
const root = createRoot(rootElement);

root.render(
  module.default({
    apiKeys,
  }),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
